import { useMemo } from "react";
import { Page } from "../../../types";

// Get the free pages, then one more, which will be blurred
export function useGetReadablePages(releasePages?: Page[]) {
  const readablePages = useMemo(() => {
    const pages = releasePages ?? [];
    const freePages = pages.filter((page) => !page.display_paid_access_block);
    if (pages[freePages.length]) {
      freePages?.push(pages[freePages.length]);
    }
    return freePages;
  }, [releasePages]);

  return {
    readablePages,
    hasReadablePages: releasePages
      ? releasePages.length > readablePages.length
      : false,
  };
}
